<template>
    <div class="outside-container">
        <div v-if="isMagicLinkConfirmed" class="magic-verified-view">
          <div class="title-container">
            <h2 class="title-2">{{ $t('titleAwesome') }}</h2>
          </div>
          <lottie :options="lottieOptions" :height="542" :width="483"/>
          <v-btn v-if="false" @click="redirectToSwiset()">
            {{ $t('btnGo') }}
          </v-btn>
        </div>
        <h1 v-if="!isMagicLinkConfirmed">Failure</h1>
     </div>
</template>

<script>
import * as animationData from '@/assets/animations/rocket.json';
import CognitoAuthRepository from "../repositories/cognitoAuth";

export default {
    data() {
        return {
            lottieOptions: { animationData: animationData.default, },
            isMagicLinkConfirmed: true
        };
    },
    mounted(){
        /* eslint-disable no-console */
        let userEmail = this.$route.query.userEmail;
        let cognitoCode = this.$route.query.cognitoCode;
        let securityCode = this.$route.query.securityCode;
        if(cognitoCode && securityCode && userEmail){
            CognitoAuthRepository.confirmMagicLink(userEmail,cognitoCode,securityCode).then((res) => {
                console.log(res)
            }).catch((err) => {
                console.log(err)
                this.isMagicLinkConfirmed = false
            })
        }else{
            // TODO show error params undefined
        }
    },
    methods: {
        redirectToSwiset(){
            window.close();
        },
    }
}
</script>


<i18n>
    {
      "en": {
        "btnGo":"Go Swiset",
        "titleAwesome":"Awesome! Let's go Swiset..."
      },
      "es": {
        "btnGo":"Ir a Swiset",
        "titleAwesome":"Genial! Ya puedes ir a Swiset..."
      }
    }
</i18n>

<style lang="scss">
  .outside-container {
    display: flex;
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: var(--v-baseBackground-base);

    .magic-verified-view{
      display: flex;
      width: 100%;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: auto;

      .title-2{
        display: flex;
        justify-content: center;
        color: var(--v-mainBlack-base);
        font-size: 30px;
        font-weight: 700;
        font-family: "Product Sans", sans-serif;
      }
      button{
        background-color: var(--v-mainBtnBackground-base) !important;
        color: var(--v-mainBlack-base) !important;
        &:hover{
          background-color: var(--v-brandAccent-base) !important;
        }
      }
    }
  }
</style>
